module.exports = __webpack_public_path__ + "__static/site-1783523783704/img/triangles.9c0edc66.png";